import React, { useEffect, useMemo, useState } from 'react';
import KapalService from '../../services/kapal/KapalService';

const PelabuhanPendaratan = ({id}) => {
    let kapalService = useMemo(() => new KapalService(), [])
    const [namaPelabuhan, setNamaPelabuhan] = useState('')

    useEffect(() => {
        const getNamaPelabuhan = async () => {
            const response = await kapalService.findPelabuhanPendaratanByKode(id)
            setNamaPelabuhan(response.data.namaPelabuhan)
        }
        getNamaPelabuhan()
    }, [kapalService, id])

    return (
        <>
            {namaPelabuhan}
        </>
    )
}

export default PelabuhanPendaratan